'use client';

import React, { memo, useMemo } from 'react';
import Link from 'next/dist/client/link';
import Image from 'next/image';

import { ITypo } from '@/app/_components/common';
import { Icons } from '@/app/assets/Icons';
import { ROUTERS } from '@/constants';
import { useGetCoursesQuery } from '@/store/api/course.api';
import { colors } from '@/theme';
import { getQueryString, map } from '@/utils';

import Wrapper from '../Wrapper';
import ContactInformation from './ContactInformation';

import { Location } from 'iconsax-react';

const addresses = [
	'Cơ sở 1: K20/14 - 16 Hoàng Hoa Thám, P. Tân Chính, Q. Thanh Khê, TP. Đà Nẵng',
	'Cơ sở 2: 136 Lê Thanh Nghị, P. Hoà Cường Bắc, Q. Hải Châu, TP. Đà Nẵng',
	'Cơ sở 3: 151 Lê Lợi, P. Thạch Thang, Q. Hải Châu, TP. Đà Nẵng',
	'Cơ sở 4: Tầng 5, 22 Lê Thánh Tôn, P. Thạch Thang, Q. Hải Châu, TP. Đà Nẵng',
];

const Footer = () => {
	const { data } = useGetCoursesQuery(getQueryString({ populate: 'image' }));
	const courses = useMemo(() => data?.data || [], [data]);
	return (
		<div className="bg-mauvelous text-black-1">
			<Wrapper className="col items-center gap-6 p-10 max-lg:hidden lg:p-10">
				<div className="col items-center gap-10">
					<Link href={ROUTERS.HOME}>
						<div className="relative  h-[93px] w-[50px]">
							<Image
								src={Icons.common.logo}
								fill
								alt="DLA Da Nang"
							/>
						</div>
					</Link>

					<div className="text-black-1 flex gap-[89px]">
						<div className="col max-w-[432px] gap-6">
							<ITypo as="h3" size={20} weight="semi">
								DLA Academy - Dream Life Activation
							</ITypo>
							<ITypo as="p" size={16} className="text-justify">
								Với hơn 20 năm kinh nghiệm, DLA cung cấp các
								khóa luyện thi PTE, IELTS cấp tốc và nhiều
								chương trình khác, giúp hơn 12.000 học viên đạt
								mục tiêu thông qua lộ trình học tập Cá nhân hoá
								hiệu quả. Phương châm “Học thật, Dạy thật, Kết
								quả thật” đảm bảo từng học viên đạt mục tiêu cải
								thiện tiếng Anh, hỗ trợ quá trình du học, làm
								việc và định cư nước ngoài.
							</ITypo>
						</div>

						<div className="col gap-6">
							<ITypo as="h3" size={20} weight="semi">
								CÁC KHÓA HỌC CÁ NHÂN HOÁ CHUYÊN SÂU
							</ITypo>

							<div className="col gap-3">
								{map(courses, (item: any, idx) => (
									<Link
										key={idx}
										href={ROUTERS.COURSE_DETAIL.replace(
											':slug',
											item?.slug
										)}
									>
										<ITypo as="p" size={16}>
											• {item?.name}
										</ITypo>
									</Link>
								))}
							</div>
						</div>

						<ContactInformation />
					</div>
				</div>
				<div className="col w-full gap-4">
					<ITypo as="h3" size={20} weight="semi">
						HỆ THỐNG CÁC CƠ SỞ
					</ITypo>
					<div className="row-between text-black-1">
						<div className="col gap-2">
							{map(addresses.slice(0, 2), (item, idx) => (
								<div key={idx} className="flex gap-2">
									<Location
										size={24}
										color={colors.black[1]}
									/>
									<ITypo size={16} as="p">
										{item}
									</ITypo>
								</div>
							))}
						</div>
						<div className="col gap-2">
							{map(addresses.slice(2), (item, idx) => (
								<div key={idx} className="flex gap-2">
									<Location
										size={24}
										color={colors.black[1]}
									/>
									<ITypo size={16} as="p">
										{item}
									</ITypo>
								</div>
							))}
						</div>
					</div>
				</div>
			</Wrapper>

			<div className="center col bg-bittersweet px-3 py-6 text-center text-white">
				<ITypo size={10} as="p" className="lg:text-14 lg:max-w-[910px]">
					CÔNG TY CỔ PHẦN GIÁO DỤC QUỐC TẾ DLA | Giấy ĐKKD số
					0401765207 do Sở Kế hoạch và Đầu tư TP. Đà Nẵng cấp ngày
					18/05/2016
				</ITypo>
			</div>
		</div>
	);
};

export default memo(Footer);
